import React from "react";
import FlippingCard from "../FlippingCard";

import { isLandscape } from "@/modules/commonMobile";

import "./index.scss";
import { ILanguageType } from "@/types/GlobalTypes";

interface INiuNiuResultType {
	pcode: string; 

	firstCard: string;
	banker: string;
	player1: string; // "9s-Ah-4d-Ac-Jd",
	player2: string;
	player3: string;
	valueBanker: string; // "bull0",
	valuePlayer1: string;
	valuePlayer2: string;
	valuePlayer3: string;
	winners: string[];
	submit: boolean;
	periode: number; //344,
	gameSet: number; //": 425
}

interface IProps {
	langdata: ILanguageType,
	mobile?: boolean;
	niuNiuResult: INiuNiuResultType;
}

export default class NiuNiuVirtualCards extends React.Component<IProps> {
	render() {
		// console.log("NNVC props", this.props);
		const { langdata, niuNiuResult } = this.props;
		
		//Todo: use translations
		// const playerNames = [this.props.langdata["txt_banker"], this.props.langdata["txt_player"]];
		const playerNames = {
			"banker": langdata["txt_banker"],
			"player1": langdata["txt_player"] + " 1",
			"player2": langdata["txt_player"] + " 2",
			"player3": langdata["txt_player"] + " 3"
		};
		
		const valueNames = {
			"banker": "valueBanker",
			"player1": "valuePlayer1",
			"player2": "valuePlayer2",
			"player3": "valuePlayer3"
		};

		if (!this.props.niuNiuResult ||
			!this.props.niuNiuResult.firstCard)
			return null;

		const cardsOutput = function(key: string, keyIdx: number) {
			const comparisonValue = niuNiuResult[valueNames[key]];
			const lastValueChar = comparisonValue[comparisonValue.length - 1];
			
			return (
				<div key={`tRK_${keyIdx}`} className="card-row">
					<div className="name">
						{ playerNames[key] }
					</div>
					
					<div className="value">
					{
						// Shows card sum when any row is full (no "x")
						niuNiuResult[key].indexOf("x") < 0 ? (
							isNaN(lastValueChar) ? "NB" :
							lastValueChar === "0" ? "BB" :
							"B" + lastValueChar
						) : null
					}
					</div>
					
					{
						niuNiuResult[key].split("-").map((card, cardIdx) =>
							<div key={"NNVC_nNR_" + keyIdx + "_" + cardIdx} className="card">
								<FlippingCard active={card !== "x"} cardImage={card} />
							</div>
						)
					}
				</div>
			);
		};
		
		return this.props.mobile && isLandscape() ? (
			<div className="niuniu-virtual-card-container">
				<div className="first-card-container">
					<FlippingCard
						active={this.props.niuNiuResult.firstCard !== "x"}
						cardImage={this.props.niuNiuResult.firstCard} />
				</div>
			
				<div className="left-side-container">
				{
					["banker", "player1"].map(cardsOutput)
				}
				</div>
				
				<div className="right-side-container">
				{
					["player2", "player3"].map(cardsOutput)
				}
				</div>
			</div>
		) : (
			<div className="niuniu-virtual-card-container">
				<div className="first-card-container">
					<FlippingCard
						active={this.props.niuNiuResult.firstCard !== "x"}
						cardImage={this.props.niuNiuResult.firstCard} />
				</div>
			{
				["banker", "player1", "player2", "player3"].map(cardsOutput)
			}
			</div>
		);
	}
}